import { render, staticRenderFns } from "./zd-jk.vue?vue&type=template&id=05954e5c&scoped=true&"
import script from "./zd-jk.vue?vue&type=script&lang=js&"
export * from "./zd-jk.vue?vue&type=script&lang=js&"
import style0 from "./zd-jk.vue?vue&type=style&index=0&id=05954e5c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05954e5c",
  null
  
)

export default component.exports